module.exports = __webpack_public_path__ + "media/media/distributors/ahmed-el-shafie-2-9241fb3fef12feabd0a7d3318530519c.jpg";